export const categories = [
  { id: "society", name: "社会", desc: "聚焦社会民生、公共事件与城市动态，还原事件真实全貌。", icon: "ri-group-line" },
  { id: "entertainment", name: "娱乐", desc: "影视、音乐与明星动态，追踪文娱行业最新热点。", icon: "ri-movie-line" },
  { id: "finance", name: "财经", desc: "宏观经济、市场行情与企业动向，洞察财富走向。", icon: "ri-line-chart-line" },
  { id: "tech", name: "科技", desc: "互联网、人工智能与数码新品，把脉科技前沿。", icon: "ri-cpu-line" },
  { id: "livelihood", name: "民生", desc: "衣食住行、社区服务与政策落地，关注你我的日常。", icon: "ri-home-heart-line" },
  { id: "sports", name: "体育", desc: "赛场内外、赛事资讯与运动员故事，感受竞技热度。", icon: "ri-basketball-line" },
  { id: "health", name: "健康", desc: "医疗科普、公共卫生与健康生活方式，守护家人安康。", icon: "ri-heart-pulse-line" },
  { id: "education", name: "教育", desc: "升学政策、校园动态与家庭教育，陪伴成长每一步。", icon: "ri-book-open-line" },
];

export const regions = ["全国", "北京", "上海", "广东", "浙江", "四川", "江苏", "湖北"];

export const articles = [
  {
    id: "n1001",
    title: "城市暴雨内涝实测：新建排水系统经受住了考验",
    summary: "连续强降雨后，记者实测多个易涝路段，新建改造的排水系统在峰值时段表现稳定，积水退去时间较往年明显缩短。",
    content: [
      "近日，我市连续遭遇强降雨天气，多个低洼路段一度出现积水。记者跟随市政部门走访了主城区几个历史易涝点，实地观察排水系统的运行情况。",
      "在改造后的城北立交，记者看到积水在雨势减弱后约二十分钟内基本排空。现场值守的工作人员介绍，新铺设的大口径雨水管与新增的两处蓄排设施有效分担了管网压力。",
      "市政部门表示，本轮降雨是对城市排水能力的一次检验，后续将根据实测数据继续优化重点路段的分流方案，并向社会公开整改进度。",
      "市民如发现新的积水点位，可通过官方渠道反馈，相关部门将纳入下一轮排查清单。",
    ],
    category: "society",
    region: "北京",
    type: "image",
    source: "51爆料网 城市观察",
    author: "本站编辑组",
    publishTime: "2026-10-14 09:24",
    views: 48620,
    comments: 318,
    cover: "https://readdy.ai/api/search-image?query=Heavy%20rain%20city%20street%20with%20wet%20asphalt%20and%20reflections%2C%20dramatic%20grey%20sky%2C%20editorial%20news%20photography%2C%20clean%20composition%2C%20muted%20tones%2C%20high%20detail&width=1200&height=800&seq=news-cover-01&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Waterlogged%20city%20intersection%20after%20rainstorm%20with%20traffic%20reflections%2C%20editorial%20documentary%20photo%2C%20muted%20blue%20tones&width=1200&height=800&seq=news-gal-01a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Underground%20city%20drainage%20pipes%20under%20construction%2C%20industrial%20infrastructure%2C%20editorial%20photography%2C%20cool%20tones&width=1200&height=800&seq=news-gal-01b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Municipal%20workers%20inspecting%20street%20manhole%20at%20dusk%2C%20documentary%20news%20photo%2C%20muted%20palette&width=1200&height=800&seq=news-gal-01c&orientation=landscape",
    ],
    video: "",
    featured: true,
    tags: ["城市", "防汛", "民生"],
  },
  {
    id: "n1002",
    title: "深夜食堂里的暖心接力：小店为环卫工免费提供热汤",
    summary: "一家开在小巷里的面馆连续三年为深夜作业的环卫工人免费供应热汤面，街坊邻居自发加入，成了这条街的深夜温度。",
    content: [
      "凌晨两点，城市渐渐安静下来，而巷口这家不足二十平米的小面馆却亮着灯。老板老周说，最早只是看见几位扫街的师傅蹲在路边啃冷馒头，就顺手煮了碗面。",
      "没想到这一煮就是三年。如今，附近几家店铺也陆续加入，有人送菜，有人送热水，还有人默默在桌上留下面钱。",
      "环卫工人李师傅说，这碗面暖的不只是胃。记者采访时，一位刚下夜班的年轻人也端着碗坐了下来，大家没有多说话，只是彼此点了点头。",
      "老周说，店不大，能做的就是让深夜还在路上的人，有口热乎的。",
    ],
    category: "society",
    region: "上海",
    type: "image",
    source: "51爆料网 民生一线",
    author: "特约通讯员",
    publishTime: "2026-10-14 08:10",
    views: 52340,
    comments: 512,
    cover: "https://readdy.ai/api/search-image?query=Cozy%20late%20night%20small%20noodle%20shop%20with%20warm%20glowing%20light%2C%20steaming%20bowl%20on%20table%2C%20editorial%20documentary%20photography%2C%20warm%20tones%2C%20high%20detail&width=1200&height=800&seq=news-cover-02&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Owner%20serving%20hot%20noodle%20soup%20to%20street%20workers%20at%20night%2C%20warm%20light%2C%20documentary%20news%20photo&width=1200&height=800&seq=news-gal-02a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Steaming%20bowl%20of%20soup%20close%20up%20on%20wooden%20table%2C%20warm%20ambient%20light%2C%20editorial%20food%20photography&width=1200&height=800&seq=news-gal-02b&orientation=landscape",
    ],
    video: "",
    featured: true,
    tags: ["暖闻", "城市", "善意"],
  },
  {
    id: "n1003",
    title: "国产大模型发布新版本，多模态能力再进一步",
    summary: "国内团队发布新一代大模型，在图像理解、长文档处理与端侧部署上明显提升，多家企业宣布接入。",
    content: [
      "今日，国内一支人工智能团队正式发布其新一代大模型。相比上一版本，新模型在多模态理解、超长上下文处理和推理效率上均有明显提升。",
      "发布会现场演示中，模型能够在数秒内完成对一份近百页图文报告的摘要与关键数据提取，并输出结构化结论。",
      "团队负责人表示，新模型同步开放端侧轻量版本，可在普通移动设备上本地运行，兼顾隐私与响应速度。",
      "目前已有来自办公、教育、医疗等行业的数十家企业宣布接入，相关应用预计在数月内陆续上线。",
    ],
    category: "tech",
    region: "浙江",
    type: "text",
    source: "51爆料网 科技频道",
    author: "科技报道组",
    publishTime: "2026-10-14 07:42",
    views: 39880,
    comments: 246,
    cover: "https://readdy.ai/api/search-image?query=Abstract%20artificial%20intelligence%20neural%20network%20visualization%2C%20deep%20blue%20and%20teal%20gradient%2C%20futuristic%20technology%20concept%2C%20clean%20minimal%20composition&width=1200&height=800&seq=news-cover-03&orientation=landscape",
    images: [],
    video: "",
    featured: true,
    tags: ["人工智能", "大模型", "科技"],
  },
  {
    id: "n1004",
    title: "文旅市场持续升温，小城“反向旅游”成新趋势",
    summary: "假期数据显示，越来越多游客选择前往非热门小城，错峰出游、深度体验带动县域文旅消费快速增长。",
    content: [
      "最新旅游平台数据显示，本季度县域目的地订单量同比增长明显，多个此前并不知名的小城成为新晋热门。",
      "游客更倾向于放慢节奏，住进当地民宿、逛菜市场、体验手作工坊。一位来自城市的游客说，她更想在旅行里“过几天当地人的日子”。",
      "业内人士分析，交通条件改善与社交平台的传播，让“反向旅游”成为可能，也对小城的接待能力提出了新要求。",
      "多地已开始完善停车、导览与公共服务配套，希望在流量到来时留得住人、也留得下口碑。",
    ],
    category: "entertainment",
    region: "四川",
    type: "image",
    source: "51爆料网 生活观察",
    author: "本站编辑组",
    publishTime: "2026-10-13 21:36",
    views: 31250,
    comments: 187,
    cover: "https://readdy.ai/api/search-image?query=Charming%20old%20small%20town%20street%20with%20lanterns%20and%20mountains%20in%20background%2C%20travel%20editorial%20photography%2C%20warm%20muted%20tones%2C%20high%20detail&width=1200&height=800&seq=news-cover-04&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Cozy%20guesthouse%20courtyard%20in%20small%20town%2C%20travel%20documentary%20photo%2C%20soft%20natural%20light&width=1200&height=800&seq=news-gal-04a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Local%20town%20market%20with%20fresh%20produce%2C%20travel%20editorial%20photography%2C%20warm%20tones&width=1200&height=800&seq=news-gal-04b&orientation=landscape",
    ],
    video: "",
    featured: false,
    tags: ["文旅", "旅游", "消费"],
  },
  {
    id: "n1005",
    title: "新能源汽车渗透率创新高，产业链加速升级",
    summary: "最新行业数据显示，新能源汽车市场渗透率再刷纪录，电池、充电与智能驾驶环节投资持续走高。",
    content: [
      "行业协会发布的最新数据显示，本季度新能源汽车市场渗透率进一步提升，销量结构持续向中高端延伸。",
      "配套的充电网络建设明显提速，多个城市在老旧小区改造中同步加装充电设施，缓解了“充电难”问题。",
      "在产业链上游，动力电池技术路线更加多元，快充与安全性能成为竞争焦点；智能驾驶则从高速场景逐步走向城市道路。",
      "分析人士提示，行业高速发展的同时也面临价格竞争与产能规划问题，理性投资仍是关键。",
    ],
    category: "finance",
    region: "广东",
    type: "text",
    source: "51爆料网 财经观察",
    author: "财经报道组",
    publishTime: "2026-10-13 18:20",
    views: 28760,
    comments: 143,
    cover: "https://readdy.ai/api/search-image?query=Modern%20electric%20vehicle%20charging%20station%20at%20dusk%2C%20clean%20industrial%20design%2C%20editorial%20photography%2C%20cool%20blue%20tones%2C%20high%20detail&width=1200&height=800&seq=news-cover-05&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["新能源", "汽车", "产业"],
  },
  {
    id: "n1006",
    title: "城中村改造提速：老楼加装电梯的“最后一公里”",
    summary: "多个老旧小区完成电梯加装，居民出行难题得到缓解，费用分摊与后续维保成为关注焦点。",
    content: [
      "在建成超过二十年的老小区里，加装电梯一度是居民最盼望、也最难推动的事。记者走访发现，随着流程优化和补贴落地，越来越多楼栋装上了电梯。",
      "居民王阿姨说，以前拎着菜爬六楼要歇两回，现在几分钟就到家了。"
      ,
      "不过，费用如何分摊、低楼层住户的意见如何协调、后续维保由谁负责，仍是绕不开的难题。",
      "社区工作人员表示，他们尝试引入“楼栋议事会”，把账算清楚、把方案讲明白，让加装电梯这件事真正办到大家心坎上。",
    ],
    category: "livelihood",
    region: "江苏",
    type: "image",
    source: "51爆料网 民生一线",
    author: "特约通讯员",
    publishTime: "2026-10-13 15:05",
    views: 22140,
    comments: 176,
    cover: "https://readdy.ai/api/search-image?query=Newly%20installed%20elevator%20on%20old%20residential%20building%20facade%2C%20daylight%2C%20editorial%20documentary%20photography%2C%20clean%20composition&width=1200&height=800&seq=news-cover-06&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Elderly%20resident%20smiling%20inside%20modern%20elevator%2C%20documentary%20news%20photo%2C%20soft%20light&width=1200&height=800&seq=news-gal-06a&orientation=landscape",
    ],
    video: "",
    featured: false,
    tags: ["民生", "社区", "改造"],
  },
  {
    id: "n1007",
    title: "全运会新星涌现，年轻选手的表现引发关注",
    summary: "本届赛事中多位“00后”选手表现亮眼，梯队建设成效初显，多个项目刷新个人最好成绩。",
    content: [
      "运动会赛程过半，多个项目涌现出年轻面孔。他们在赛场上敢打敢拼，刷新了不少个人与赛会纪录。",
      "教练团队表示，近年来青训体系不断完善，年轻选手获得了更多高水平比赛的锻炼机会。",
      "一位年仅十七岁的小将赛后说，比起名次，她更在意自己每一场是否比上一场更进一步。",
      "专家认为，新老交替的良性循环，是项目保持竞争力的关键。",
    ],
    category: "sports",
    region: "湖北",
    type: "image",
    source: "51爆料网 体育频道",
    author: "体育报道组",
    publishTime: "2026-10-13 11:48",
    views: 19870,
    comments: 98,
    cover: "https://readdy.ai/api/search-image?query=Young%20athlete%20running%20on%20track%20stadium%2C%20dynamic%20motion%2C%20editorial%20sports%20photography%2C%20warm%20sunset%20light%2C%20high%20detail&width=1200&height=800&seq=news-cover-07&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["体育", "赛事", "新星"],
  },
  {
    id: "n1008",
    title: "秋季流感高发，医生提醒这些人群尽早接种疫苗",
    summary: "进入秋季后呼吸道疾病就诊量上升，医生建议老人、儿童及慢性病患者尽早接种流感疫苗并做好日常防护。",
    content: [
      "随着气温下降，医院呼吸科门诊量明显增加。医生介绍，秋季是流感等呼吸道传染病的高发期。",
      "医生建议，老年人、儿童、孕妇及有慢性基础疾病的人群应尽早接种疫苗，同时保持勤洗手、常通风的良好习惯。",
      "如果出现持续高热、呼吸急促等症状，应及时就医，避免自行用药延误病情。",
      "此外，均衡饮食、规律作息与适度锻炼，也有助于提升自身免疫力。",
    ],
    category: "health",
    region: "全国",
    type: "text",
    source: "51爆料网 健康频道",
    author: "健康科普组",
    publishTime: "2026-10-13 09:30",
    views: 24310,
    comments: 132,
    cover: "https://readdy.ai/api/search-image?query=Doctor%20holding%20vaccine%20vial%20in%20clinic%2C%20clean%20medical%20environment%2C%20editorial%20health%20photography%2C%20soft%20light%2C%20high%20detail&width=1200&height=800&seq=news-cover-08&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["健康", "流感", "疫苗"],
  },
  {
    id: "n1009",
    title: "“课间一刻钟”落地观察：孩子们终于跑起来了",
    summary: "多地将课间休息时间延长，鼓励学生走出教室。记者走访发现，孩子们的笑容多了，学校也在探索安全管理的新办法。",
    content: [
      "下课铃响，操场上很快热闹起来。随着“课间一刻钟”政策落地，学生们有了更充裕的活动时间。",
      "一位班主任说，以前担心安全，总想把孩子留在教室，如今学校增加了值班老师和活动区域划分，顾虑少了很多。",
      "有家长反馈，孩子回家后精神状态更好了，写作业的注意力也更集中。",
      "教育专家表示，把课间还给孩子，看似小事，实则关系到身心健康与学习效率。",
    ],
    category: "education",
    region: "浙江",
    type: "image",
    source: "51爆料网 教育频道",
    author: "教育观察组",
    publishTime: "2026-10-12 20:15",
    views: 17640,
    comments: 205,
    cover: "https://readdy.ai/api/search-image?query=Happy%20school%20children%20playing%20on%20playground%20at%20recess%2C%20bright%20daylight%2C%20editorial%20documentary%20photography%2C%20warm%20tones%2C%20high%20detail&width=1200&height=800&seq=news-cover-09&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["教育", "校园", "课间"],
  },
  {
    id: "n1010",
    title: "老街夜市回归：烟火气里的小城夜经济",
    summary: "经过改造的老街夜市重新开放，摊位规范有序、人气回升，成为周边居民夜间休闲的新去处。",
    content: [
      "傍晚六点，老街的灯笼次第亮起。经过数月的改造，这条承载几代人记忆的夜市重新热闹起来。",
      "新夜市对摊位布局、卫生和噪声管理做了规范，既有熟悉的老味道，也添了不少年轻摊主的新创意。",
      "一位卖糖画的老师傅说，他在这条街摆摊三十年，看到人气回来，心里踏实。",
      "管理方表示，夜经济既要热闹，也要有序，将根据商户和居民反馈持续优化。",
    ],
    category: "livelihood",
    region: "四川",
    type: "image",
    source: "51爆料网 城市观察",
    author: "本站编辑组",
    publishTime: "2026-10-12 19:02",
    views: 15920,
    comments: 121,
    cover: "https://readdy.ai/api/search-image?query=Bustling%20night%20market%20street%20with%20warm%20lanterns%20and%20food%20stalls%2C%20editorial%20photography%2C%20warm%20tones%2C%20high%20detail&width=1200&height=800&seq=news-cover-10&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Street%20food%20vendor%20preparing%20skewers%20at%20night%20market%2C%20warm%20light%2C%20documentary%20photo&width=1200&height=800&seq=news-gal-10a&orientation=landscape",
    ],
    video: "",
    featured: false,
    tags: ["夜经济", "城市", "消费"],
  },
  {
    id: "n1011",
    title: "纪录片聚焦普通人的坚守，观众直呼“看见了自己”",
    summary: "一部讲述平凡岗位故事的纪录片上线后引发讨论，真实细腻的镜头语言打动了不少观众。",
    content: [
      "近日，一部以普通劳动者为主角的纪录片上线，没有宏大叙事，却让许多观众在弹幕里写下“这就是我”。",
      "片中记录了凌晨的公交司机、深夜的急诊护士、风雨中的外卖骑手。镜头克制，却处处是生活的重量。",
      "导演在采访中表示，他更想呈现的是“认真生活”本身的美感，而不是刻意煽情。",
      "有观众说，看完后对身边的人多了几分理解，这或许就是纪录片的意义。",
    ],
    category: "entertainment",
    region: "北京",
    type: "video",
    source: "51爆料网 文娱观察",
    author: "文娱报道组",
    publishTime: "2026-10-12 16:40",
    views: 21480,
    comments: 264,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20city%20street%20at%20dawn%20with%20lone%20worker%20silhouette%2C%20documentary%20film%20still%2C%20moody%20blue%20tones%2C%20high%20detail&width=1200&height=800&seq=news-cover-11&orientation=landscape",
    images: [],
    video: "https://example.com/demo-video.mp4",
    featured: false,
    tags: ["纪录片", "文娱", "人物"],
  },
  {
    id: "n1012",
    title: "社区食堂开到楼下：一顿热饭背后的民生账本",
    summary: "社区食堂陆续落地，为老人和上班族提供平价餐食，运营可持续性成为各方关注的焦点。",
    content: [
      "中午十一点半，社区食堂里已经排起了队。老人、上班族、带着孩子的家长，在这里都能吃上一顿实惠的热饭。",
      "食堂负责人介绍，通过集中采购和错峰经营控制成本，价格比周边餐馆低三成左右。",
      "社区则通过提供场地、组织志愿者等方式给予支持，让食堂能够长期运转。",
      "居民说，吃的不只是饭，还有一份邻里之间的踏实感。",
    ],
    category: "livelihood",
    region: "上海",
    type: "image",
    source: "51爆料网 民生一线",
    author: "特约通讯员",
    publishTime: "2026-10-12 12:28",
    views: 14260,
    comments: 97,
    cover: "https://readdy.ai/api/search-image?query=Bright%20community%20canteen%20with%20elderly%20residents%20having%20lunch%2C%20clean%20interior%2C%20editorial%20documentary%20photography%2C%20warm%20tones&width=1200&height=800&seq=news-cover-12&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["民生", "社区", "养老"],
  },
  {
    id: "n1013",
    title: "量子计算研究取得进展，实验平台开放共享",
    summary: "研究团队公布新成果，相关实验平台将向高校与科研机构开放，推动交叉领域合作。",
    content: [
      "研究团队近日公布了在量子计算方向上的阶段性成果，相关论文已公开发表。",
      "团队介绍，此次的进展主要体现在纠错与稳定性方面，为后续规模化应用打下基础。",
      "同时，实验平台将面向高校和科研机构开放共享，降低研究门槛，促进跨学科合作。",
      "专家提醒，量子计算的产业化仍需较长时间，应保持耐心与长期投入。",
    ],
    category: "tech",
    region: "北京",
    type: "text",
    source: "51爆料网 科技频道",
    author: "科技报道组",
    publishTime: "2026-10-11 22:10",
    views: 13480,
    comments: 76,
    cover: "https://readdy.ai/api/search-image?query=Quantum%20computing%20laboratory%20with%20glowing%20cryogenic%20equipment%2C%20futuristic%20science%20concept%2C%20deep%20blue%20tones%2C%20high%20detail&width=1200&height=800&seq=news-cover-13&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["量子计算", "科研", "科技"],
  },
  {
    id: "n1014",
    title: "快递进村：农产品出山的路，越来越顺了",
    summary: "随着村级寄递服务点铺开，山货出村、网购进村更加便利，农户增收渠道进一步拓宽。",
    content: [
      "在过去，山路难行，村里的水果常常因为运不出去而烂在地里。如今，寄递服务点开到了村委会旁。",
      "农户说，上午摘下的果子，下午就能发出，第二天就到了城里的餐桌。",
      "服务点的建立，也让村民网购更加方便，日用品、农资都能送到家门口。",
      "相关负责人表示，下一步将继续完善冷链和分拣设施，让农产品走得更远。",
    ],
    category: "finance",
    region: "四川",
    type: "image",
    source: "51爆料网 财经观察",
    author: "财经报道组",
    publishTime: "2026-10-11 17:36",
    views: 11240,
    comments: 64,
    cover: "https://readdy.ai/api/search-image?query=Rural%20village%20parcel%20delivery%20point%20with%20boxes%20and%20mountains%20behind%2C%20editorial%20documentary%20photography%2C%20warm%20daylight&width=1200&height=800&seq=news-cover-14&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["物流", "乡村", "增收"],
  },
  {
    id: "n1015",
    title: "公园里的“适老化”改造：长椅、坡道与一盏暖灯",
    summary: "城市公园陆续推进适老化改造，增设休息座椅、无障碍坡道与夜间照明，让老人散步更安心。",
    content: [
      "午后，几位老人在公园新修的林荫步道上散步。步道旁新增了不少带扶手的座椅。",
      "公园管理处介绍，此次改造重点关注老年人的实际需求，包括无障碍坡道、防滑地面和更柔和的夜间照明。",
      "一位常来锻炼的老人说，以前台阶多、灯也暗，现在出来遛弯心里踏实多了。",
      "工作人员表示，后续还会根据居民建议继续完善配套设施。",
    ],
    category: "society",
    region: "江苏",
    type: "image",
    source: "51爆料网 城市观察",
    author: "本站编辑组",
    publishTime: "2026-10-11 14:22",
    views: 9860,
    comments: 58,
    cover: "https://readdy.ai/api/search-image?query=Peaceful%20urban%20park%20path%20with%20benches%20and%20elderly%20people%20walking%2C%20soft%20afternoon%20light%2C%20editorial%20photography&width=1200&height=800&seq=news-cover-15&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["养老", "城市", "公共服务"],
  },
  {
    id: "n1016",
    title: "高校宿舍改造升级，学生直呼“幸福感拉满”",
    summary: "多所高校利用假期对宿舍进行改造，增设独立卫浴、公共学习空间，改善学生居住体验。",
    content: [
      "新学期开学，不少学生发现宿舍焕然一新。独立卫浴、空调和收纳空间的改善，让大家惊喜不已。",
      "学校相关负责人介绍，改造还增设了公共洗衣房、自习室和活动室，希望营造更舒适的生活与学习环境。",
      "有学生说，宿舍环境好了，学习和生活的状态也更积极了。",
      "校方表示，后续将根据学生反馈继续优化公共区域的服务与管理。",
    ],
    category: "education",
    region: "湖北",
    type: "image",
    source: "51爆料网 教育频道",
    author: "教育观察组",
    publishTime: "2026-10-11 10:18",
    views: 12480,
    comments: 112,
    cover: "https://readdy.ai/api/search-image?query=Modern%20bright%20university%20dormitory%20room%20with%20study%20desks%2C%20clean%20interior%20design%2C%20editorial%20photography%2C%20soft%20light&width=1200&height=800&seq=news-cover-16&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["教育", "校园", "宿舍"],
  },
  {
    id: "n1017",
    title: "马拉松赛事带动城市活力，跑者用脚步丈量街道",
    summary: "金秋时节多场马拉松开跑，参赛人数再创新高，赛事也带动了周边餐饮与住宿消费。",
    content: [
      "清晨的发令枪响，数万名跑者涌上街道。沿途市民自发加油，成了这座城市最热闹的风景。",
      "不少外地跑者提前到达，顺便游览了城市景点，带动了餐饮、住宿和交通消费。",
      "赛事组织方介绍，本届在补给、医疗和志愿服务上做了充分准备，保障选手安全完赛。",
      "一位跑龄十年的选手说，跑过一座座城市的街道，是他理解城市最好的方式。",
    ],
    category: "sports",
    region: "广东",
    type: "image",
    source: "51爆料网 体育频道",
    author: "体育报道组",
    publishTime: "2026-10-10 21:44",
    views: 13820,
    comments: 88,
    cover: "https://readdy.ai/api/search-image?query=Marathon%20runners%20crowd%20on%20city%20street%20with%20banners%2C%20energetic%20editorial%20sports%20photography%2C%20bright%20morning%20light&width=1200&height=800&seq=news-cover-17&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["马拉松", "体育", "城市"],
  },
  {
    id: "n1018",
    title: "“为你好”式育儿引热议，专家呼吁多些倾听",
    summary: "一段亲子对话视频引发讨论，教育工作者提醒家长，过度干预可能适得其反，理解与沟通更为重要。",
    content: [
      "近日，一段家长与孩子之间的对话视频在网上引发广泛讨论，不少网友在其中看到了自己的影子。",
      "教育工作者指出，许多家长习惯用“为你好”来表达爱，却忽略了孩子真实的感受与表达需求。",
      "专家建议，家长可以多问一句“你是怎么想的”，把协商的空间留给孩子，让沟通成为双向的。",
      "也有家长坦言，放下焦虑并不容易，需要不断学习和调整，这本身也是一种成长。",
    ],
    category: "education",
    region: "北京",
    type: "text",
    source: "51爆料网 教育频道",
    author: "教育观察组",
    publishTime: "2026-10-10 18:12",
    views: 15640,
    comments: 231,
    cover: "https://readdy.ai/api/search-image?query=Parent%20talking%20gently%20with%20child%20at%20home%20table%2C%20warm%20soft%20light%2C%20editorial%20lifestyle%20photography&width=1200&height=800&seq=news-cover-18&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["教育", "家庭", "亲子"],
  },
  {
    id: "n1019",
    title: "旧物改造市集走红，年轻人爱上“修修补补”",
    summary: "一场旧物改造市集吸引众多年轻人参与，环保理念与手工乐趣结合，让“旧物新用”成为新潮流。",
    content: [
      "周末的旧物改造市集里，摊主们展示着用废旧布料、木料做成的各种小物，吸引了不少人驻足。",
      "一位摊主说，很多东西不是坏了，只是被丢得太快，修补一下又能用很久。",
      "参与者表示，动手改造的过程本身就很治愈，也让人重新思考消费与浪费的关系。",
      "主办方希望，通过这样的市集让可持续生活的理念被更多人了解和接受。",
    ],
    category: "entertainment",
    region: "上海",
    type: "image",
    source: "51爆料网 生活观察",
    author: "本站编辑组",
    publishTime: "2026-10-10 14:50",
    views: 8920,
    comments: 74,
    cover: "https://readdy.ai/api/search-image?query=Upcycled%20handmade%20crafts%20market%20stall%20with%20wooden%20and%20fabric%20items%2C%20warm%20daylight%2C%20editorial%20lifestyle%20photography&width=1200&height=800&seq=news-cover-19&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["环保", "生活方式", "市集"],
  },
  {
    id: "n1020",
    title: "基层医生的一天：在乡间守护“最后的健康防线”",
    summary: "跟随一位乡镇医生，记录他走村入户、送医上门的日常，感受基层医疗的坚守与不易。",
    content: [
      "早上七点，乡镇医生老李已经背着药箱出了门。今天他要走访村里几位行动不便的老人。",
      "山路要走四十多分钟，到了老人家里，量血压、换药、叮嘱用药，一忙就是一上午。",
      "老李说，基层医生就是乡亲们身边的“健康守门人”，能让他们少跑一趟大医院，就是值得的。",
      "近年来，随着设备与培训投入增加，基层医疗条件有了改善，但人才短缺仍是需要长期面对的问题。",
    ],
    category: "health",
    region: "四川",
    type: "image",
    source: "51爆料网 健康频道",
    author: "健康科普组",
    publishTime: "2026-10-10 11:06",
    views: 10420,
    comments: 96,
    cover: "https://readdy.ai/api/search-image?query=Country%20doctor%20carrying%20medical%20bag%20walking%20on%20rural%20path%2C%20documentary%20photography%2C%20warm%20morning%20light%2C%20high%20detail&width=1200&height=800&seq=news-cover-20&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["健康", "基层医疗", "人物"],
  },
  {
    id: "n1021",
    title: "智能垃圾分类设备进社区，居民接受度逐步提升",
    summary: "多小区试点智能垃圾分类设备，通过积分激励与语音引导提升分类准确率，管理成本同步下降。",
    content: [
      "在试点小区，居民刷卡投放垃圾，设备自动识别并给出分类提示，投放正确还能获得积分。",
      "物业负责人介绍，引入智能设备后，分类准确率明显提升，人工分拣的压力也小了不少。",
      "有居民坦言，一开始觉得麻烦，用了几次以后就习惯了，还能换点日用品，挺划算。",
      "相关负责人表示，下一步将根据试点情况优化设备功能，逐步扩大覆盖范围。",
    ],
    category: "society",
    region: "浙江",
    type: "text",
    source: "51爆料网 城市观察",
    author: "本站编辑组",
    publishTime: "2026-10-09 20:32",
    views: 7640,
    comments: 52,
    cover: "https://readdy.ai/api/search-image?query=Smart%20recycling%20station%20in%20residential%20community%20with%20digital%20screen%2C%20clean%20modern%20design%2C%20editorial%20photography%2C%20soft%20daylight&width=1200&height=800&seq=news-cover-21&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["环保", "社区", "科技"],
  },
  {
    id: "n1022",
    title: "非遗手艺人走进课堂，传统技艺有了“小小传承人”",
    summary: "非遗传承人受邀走进中小学课堂，通过体验式教学让孩子近距离感受传统文化魅力。",
    content: [
      "在课堂上，非遗传承人一边演示，一边讲解技艺背后的故事，孩子们听得格外认真。",
      "老师表示，这样的课程让孩子在动手中理解传统文化，比单纯的说教更有效果。",
      "一位学生说，以前觉得这些老手艺离自己很远，亲手做过后才明白其中的讲究和耐心。",
      "相关部门表示，将继续推动非遗进校园，让传统技艺在年轻一代手中延续下去。",
    ],
    category: "education",
    region: "江苏",
    type: "image",
    source: "51爆料网 教育频道",
    author: "教育观察组",
    publishTime: "2026-10-09 16:18",
    views: 6820,
    comments: 43,
    cover: "https://readdy.ai/api/search-image?query=Traditional%20craft%20artisan%20teaching%20children%20in%20classroom%2C%20warm%20light%2C%20editorial%20documentary%20photography%2C%20high%20detail&width=1200&height=800&seq=news-cover-22&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["非遗", "教育", "文化"],
  },
  {
    id: "n1023",
    title: "共享单车治理新招：电子围栏让停车更规范",
    summary: "多个城区试点共享单车电子围栏，引导用户规范停放，重点路段乱停乱放现象明显改善。",
    content: [
      "打开手机 App，用户只有在指定区域内才能完成还车。这是近期上线的电子围栏技术。",
      "管理部门介绍，试点以来，重点路段乱停放现象明显减少，人行道变得更加通畅。",
      "也有用户反馈，个别区域还车点偏少，希望进一步优化布点。",
      "运营方表示，将结合数据动态调整停放区域，兼顾通行秩序与使用便利。",
    ],
    category: "livelihood",
    region: "北京",
    type: "text",
    source: "51爆料网 民生一线",
    author: "特约通讯员",
    publishTime: "2026-10-09 12:40",
    views: 6480,
    comments: 61,
    cover: "https://readdy.ai/api/search-image?query=Row%20of%20shared%20bicycles%20neatly%20parked%20on%20city%20sidewalk%2C%20clean%20urban%20scene%2C%20editorial%20photography%2C%20soft%20daylight&width=1200&height=800&seq=news-cover-23&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["共享出行", "城市治理", "民生"],
  },
  {
    id: "n1024",
    title: "秋招观察：新兴岗位受青睐，求职者更看重成长空间",
    summary: "今年秋招中，人工智能、新能源等领域岗位热度上升，求职者对职业成长与工作体验的关注明显提高。",
    content: [
      "秋季招聘进入高峰，多场校园招聘会上人头攒动。人工智能、新能源、智能制造等领域的岗位备受关注。",
      "多位应届生表示，相比薪资，他们更在意岗位的成长空间与团队氛围。",
      "企业招聘负责人也提到，如今的年轻人更愿意了解岗位的长期发展路径，而不只是眼前的待遇。",
      "职业规划师建议，求职者可以结合自身兴趣与行业趋势，做出更理性的选择。",
    ],
    category: "finance",
    region: "广东",
    type: "text",
    source: "51爆料网 财经观察",
    author: "财经报道组",
    publishTime: "2026-10-09 09:14",
    views: 8120,
    comments: 79,
    cover: "https://readdy.ai/api/search-image?query=Job%20fair%20crowd%20of%20young%20graduates%20at%20booths%2C%20bright%20convention%20hall%2C%20editorial%20documentary%20photography%2C%20cool%20tones&width=1200&height=800&seq=news-cover-24&orientation=landscape",
    images: [],
    video: "",
    featured: false,
    tags: ["就业", "秋招", "职场"],
  },
];

export const carouselSlides = [
  {
    articleId: "n1001",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20city%20skyline%20under%20storm%20clouds%20with%20rain%20and%20reflections%2C%20news%20banner%20style%2C%20dark%20moody%20blue%20tones%2C%20cinematic%20high%20detail&width=1600&height=900&seq=hero-slide-01&orientation=landscape",
  },
  {
    articleId: "n1002",
    image: "https://readdy.ai/api/search-image?query=Warm%20glowing%20late%20night%20street%20food%20shop%20with%20soft%20bokeh%20lights%2C%20cinematic%20news%20banner%2C%20warm%20tones%2C%20high%20detail&width=1600&height=900&seq=hero-slide-02&orientation=landscape",
  },
  {
    articleId: "n1003",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20abstract%20digital%20network%20technology%20background%2C%20deep%20blue%20gradient%2C%20cinematic%20wide%20news%20banner%2C%20high%20detail&width=1600&height=900&seq=hero-slide-03&orientation=landscape",
  },
  {
    articleId: "n1004",
    image: "https://readdy.ai/api/search-image?query=Scenic%20ancient%20town%20at%20dusk%20with%20lanterns%20and%20mountains%2C%20cinematic%20travel%20news%20banner%2C%20warm%20muted%20tones%2C%20high%20detail&width=1600&height=900&seq=hero-slide-04&orientation=landscape",
  },
];

export const siteStats = [
  { label: "累计爆料", value: "128,600+" },
  { label: "今日更新", value: "1,240" },
  { label: "覆盖城市", value: "300+" },
  { label: "活跃读者", value: "520万" },
];